import debounce from 'lodash.debounce'

export default {
  props: {
    textBlock: {
      type: Object,
      required: true,
    },

    highlight: {
      type: Object,
    },
  },

  data() {
    return {
      availableLayouts: ['full', 'half', 'two-thirds', 'two-thirds-50'],
      availableColors: ['orange', 'blue', 'ligh-gray', 'dark-gray', 'transparent'],
      availableThemes: ['light', 'dark'],
      isMobile: null,
      imageZoom: {
        backgroundSize: 'cover',
      },
    }
  },

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.resize)
      window.dispatchEvent(new Event('resize'))
    })
  },

  destroyed() {
    window.removeEventListener('resize', this.resize)
  },

  computed: {
    isReverse() {
      if (this.textBlock.reverse) return `reverse`
    },

    hasTextBlockButton() {
      if (this.textBlock.button) return true
    },

    textBlockLayout() {
      if (this.availableLayouts.indexOf(this.textBlock.columnsLayout) !== -1) return this.textBlock.columnsLayout
    },

    textBlockBackgroundColor() {
      if (this.availableColors.indexOf(this.textBlock.backgroundColor) !== -1) return this.textBlock.backgroundColor
    },

    textBlockTheme() {
      if (this.availableThemes.indexOf(this.textBlock.textTheme) !== -1) return this.textBlock.textTheme
    },

    hasHighlight() {
      if (this.highlight) return true
    },

    highlightBackgroundColor() {
      if (this.hasHighlight && this.availableColors.indexOf(this.highlight.body.backgroundColor) !== -1)
        return this.highlight.body.backgroundColor
    },

    highlightTheme() {
      if (this.hasHighlight && this.availableThemes.indexOf(this.highlight.body.textTheme) !== -1)
        return this.highlight.body.textTheme
    },

    hasHighlightButton() {
      if (this.highlight.button) return true
    },

    hasImageAttributes() {
      const estilos = {}

      if (this.highlight && this.highlight.hasOwnProperty('image') && this.imageZoom.hasOwnProperty('backgroundSize')) {
        estilos.backgroundImage = `url(${this.highlight.image.src})`
        estilos.backgroundSize = this.imageZoom.backgroundSize
      }

      if (this.highlight && this.highlight.hasOwnProperty('image') && this.highlight.image.hasOwnProperty('zoom')) {
        estilos.backgroundImage = `url(${this.highlight.image.src})`
        estilos.backgroundSize = this.highlight.image.zoom + '%'
      }

      return estilos
    },
  },

  methods: {
    resize(e) {
      this.resizeDebounce(e, this)
    },

    resizeDebounce: debounce((e, self) => {
      if (window.innerWidth > 1024) {
        self.isMobile = false

        return
      }

      self.isMobile = true
    }, 100),
  },
}
